import React, { Component, useState, useMemo, useEffect } from "react";
import TextField from '@mui/material/TextField';
import Autocomplete from '@mui/material/Autocomplete';
import CircularProgress from '@mui/material/CircularProgress';
import { query, flattenObj } from '../App';

export default function AutocompleteText(props) {
    const [open, setOpen] = React.useState(false);
    const [options, setOptions] = React.useState(props.options ? props.options : []);
    const [loading, setLoading] = React.useState(false);
    const [searchText, setSearchText] = React.useState(undefined);
    const [currentOption, setCurrentOption] = React.useState(props.value ? props.value : null);
    const [inputValue, setInputValue] = React.useState("");
    useEffect(() => {
        if (searchText && props.serverOptions) {
            setLoading(true);
            query(`${props.queryPath}/search`, "POST",
                {
                    limit: 20,
                    skip: 0,
                    filterModel: [{
                        operator: props.searchOperator ? props.searchOperator : "equals",
                        field: props.searchBy,
                        value: searchText
                    }]
                }).then(res => {
                    res = res.rows;
                    res = res.map(r => {
                        r = Object.assign(r, flattenObj(r));
                        Object.keys(r).forEach(k => (!(props.autocomplete.includes(k)) && delete r[k]))
                        return r;
                    });
                    setOptions(res);
                    setLoading(false);
                })
        }
    }, [searchText]);
    // console.log('===========================================')
    // console.log(1, props.serverOptions, currentOption, props.value, options)

    //When options are preloaded from data value
    if (!props.serverOptions) {
        let optionToBeSet = options.find(e => {
            return e.value == currentOption;
        });
        // console.log(optionToBeSet)
        if (currentOption != optionToBeSet && optionToBeSet !== undefined) {
            if (props.setinputvalue) props.setinputvalue(props.name, props.value)
            setCurrentOption(optionToBeSet);
        }
    }
    // console.log(2, props.serverOptions, currentOption, options)
    return (
        <Autocomplete
            id={props.name}
            open={open}
            onOpen={() => {
                setOpen(true);
            }}
            onClose={() => {
                setOpen(false);
            }}
            onChange={(event, value) => {
                if (!value && !props.freeSolo) props.setinputvalue(props.name + "_autocomplete", {})
                else if (props.serverOptions) {
                    Object.keys(value).forEach(key => {
                        props.setinputvalue(key, value[key])
                    });
                    setCurrentOption(value)
                }
                else {
                    setCurrentOption(value["value"])
                    if (props.setinputvalue) props.setinputvalue(props.name, value["value"], props.setinputvalue)
                }
                if (props.onChange) props.onChange(event, value);
            }}
            freeSolo={props.freeSolo ? props.freeSolo : false}
            fullWidth
            size="small"
            filterOptions={(x) => {
                if (inputValue && !props.serverOptions) return x.filter(e => e.label.toLocaleLowerCase().includes(inputValue.toLocaleLowerCase()))
                else return x
            }}
            getOptionLabel={option => {
                if (options.length == 0) return String(option);
                if (option == "" || Object.keys(option).length == 0) return "";
                if (props.serverOptions) {
                    let str = "";
                    props.optionLabel.forEach((v, e) => {
                        let text = (option[v] ? option[v] : '');
                        if (props.optionLabel.length == e + 1) str += text;
                        else str += text + "-";
                    })
                    return str;
                }
                return String(option['label']);
            }}
            value={currentOption}
            options={options}
            loading={loading}
            disabled={props.disabled}
            renderInput={(params) => (
                <TextField
                    onChange={(e) => {
                        const saved = e.target.value;
                        setTimeout(() => {
                            if (saved == e.target.value) setSearchText(e.target.value)
                            console.log(saved, e.target.value)
                        }, 1500)
                        if (props.freeSolo && props.setinputvalue) props.setinputvalue(props.name, e.target.value)
                        setInputValue(e.target.value)
                    }}
                    {...params}
                    name={props.name}
                    label={props.label}
                    sx={{ "& input": { "color": params.InputProps.color ? params.InputProps.color : "black" } }}
                    InputProps={{
                        ...params.InputProps,
                        endAdornment: (
                            <React.Fragment>
                                {loading ? <CircularProgress color="inherit" size={20} /> : null}
                                {params.InputProps.endAdornment}
                            </React.Fragment>
                        ),
                    }}
                />
            )}
        />
    );
}